import { useSyncExternalStore } from 'react';

// Настройка «звук уведомлений» — на уровне устройства (не аккаунта): хранится в localStorage,
// по умолчанию включена. Значение читается синхронно (движок звука) и реактивно (переключатель
// в шапке) через один и тот же источник.

const STORAGE_KEY = 'data1861:notif-sound-enabled';

function read(): boolean {
  try {
    // Любое значение, кроме явного 'off', считаем «включено» → по умолчанию звук есть.
    return localStorage.getItem(STORAGE_KEY) !== 'off';
  } catch {
    // localStorage недоступен (приватный режим/квота) — работаем в памяти, звук включён.
    return true;
  }
}

let enabled = read();
const listeners = new Set<() => void>();

/** Синхронное чтение флага — для движка звука (без подписки на React). */
export function isSoundEnabled(): boolean {
  return enabled;
}

export function setSoundEnabled(value: boolean): void {
  if (value === enabled) {
    return;
  }
  enabled = value;
  try {
    localStorage.setItem(STORAGE_KEY, value ? 'on' : 'off');
  } catch {
    // localStorage недоступен — сохраняем только в памяти на время сессии.
  }
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Реактивный флаг для UI (иконка-переключатель в шапке). */
export function useSoundEnabled(): boolean {
  return useSyncExternalStore(subscribe, isSoundEnabled);
}
